export default {
    UPDATE_BASKET_VALIDATION: 'UPDATE_BASKET_VALIDATION',
    AVAILABLE_SERVICES_CHANGE: 'availableServicesChange',
    LOGOUT: 'logout',
    REDIRECT_TO_DEFAULT: 'redirectToDefault',
    REFRESH_TOKEN: 'token-refresh',
    REFRESH_SLIDER: 'refreshSlider',
};



// WEBPACK FOOTER //
// ./src/app/constants/appEvents.constant.js